import api from '../utils/api';
import { comunaParams } from '../utils/deliveryComuna';

/**
 * Servicio para manejar todas las operaciones del carrito
 *
 * Todas las llamadas mandan la comuna de despacho (task-1379): cada una devuelve
 * el resumen de reglas del carrito, y las reglas por comuna dependen de ella.
 */
export const cartService = {
  /**
   * Obtener el carrito del usuario
   */
  getCart: async () => {
    try {
      const response = await api.get('/cart', { params: comunaParams() });
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener el carrito',
        data: null,
      };
    }
  },

  /**
   * Agregar producto al carrito
   * @param {number} productId - ID del producto (internal_id)
   * @param {number} quantity - Cantidad a agregar
   */
  addItem: async (productId, quantity = 1) => {
    try {
      const response = await api.post('/cart/items', {
        product_id: productId,
        quantity: quantity,
      }, { params: comunaParams() });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al agregar producto',
        errors: error.response?.data?.errors,
      };
    }
  },

  /**
   * Actualizar cantidad de un item
   * @param {number} itemId - ID del item en el carrito
   * @param {number} quantity - Nueva cantidad
   */
  updateItem: async (itemId, quantity) => {
    try {
      const response = await api.put(`/cart/items/${itemId}`, {
        quantity: quantity,
      }, { params: comunaParams() });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar cantidad',
        errors: error.response?.data?.errors,
      };
    }
  },

  /**
   * Eliminar item del carrito
   * @param {number} itemId - ID del item a eliminar
   */
  removeItem: async (itemId) => {
    try {
      const response = await api.delete(`/cart/items/${itemId}`, { params: comunaParams() });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar producto',
      };
    }
  },

  /**
   * Limpiar todo el carrito
   */
  clearCart: async () => {
    try {
      const response = await api.delete('/cart/clear');
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al limpiar el carrito',
      };
    }
  },
};

